module.exports = "<sx-listado-desplegable \r\n[fuente]=\"grupos\"\r\n[tipo] = \"'SUBSCRIPTION' | i18next\">\r\n</sx-listado-desplegable>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/subscription/configurar.subscription.component.html
// module id = ../../../../../src/app/private/configuracion/subscription/configurar.subscription.component.html
// module chunks = main